import type { ReactNode } from "react";

import { motion } from "motion/react";

export interface DonutPart {
  key: string;
  value: number;
  /** SVG rang klassi, masalan `text-success`. */
  className: string;
}

/**
 * Halqa diagramma — bo'laklar ketma-ket chiziladi va aylana bo'ylab "o'sadi".
 * Rang `currentColor` dan: token klasslari yetarli, hex yo'q.
 */
export function Donut({
  parts,
  size = 168,
  stroke = 18,
  label,
  children,
}: {
  parts: DonutPart[];
  size?: number;
  stroke?: number;
  label: string;
  children?: ReactNode;
}) {
  const total = parts.reduce((sum, part) => sum + part.value, 0);
  const r = (size - stroke) / 2;
  const circumference = 2 * Math.PI * r;
  let offset = 0;
  return (
    <div className="relative shrink-0" style={{ width: size, height: size }}>
      <svg
        width={size}
        height={size}
        viewBox={`0 0 ${size} ${size}`}
        className="-rotate-90"
        role="img"
        aria-label={label}
      >
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          fill="none"
          stroke="currentColor"
          strokeWidth={stroke}
          className="text-muted"
        />
        {total > 0
          ? parts.map((part, index) => {
              const length = part.value / total;
              const start = offset;
              offset += length;
              return (
                <motion.circle
                  key={part.key}
                  cx={size / 2}
                  cy={size / 2}
                  r={r}
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={stroke}
                  strokeLinecap="butt"
                  className={part.className}
                  // Bo'lak o'z joyidan boshlanadi (offset) va uzunligigacha
                  // "o'sadi"; bo'laklar orasida ingichka tirqish qoladi.
                  strokeDashoffset={-start * circumference}
                  initial={{ strokeDasharray: `0 ${circumference}` }}
                  animate={{
                    strokeDasharray: `${Math.max(0, length * circumference - 2)} ${circumference}`,
                  }}
                  transition={{ duration: 1, delay: 0.2 + index * 0.25, ease: [0.16, 1, 0.3, 1] }}
                />
              );
            })
          : null}
      </svg>
      {children ? (
        <div className="absolute inset-0 grid place-items-center text-center">{children}</div>
      ) : null}
    </div>
  );
}
